/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
import {
  ArrowRightOutlined,
  CarOutlined,
  CloseCircleOutlined,
  FileDoneOutlined,
  IdcardOutlined,
  InfoCircleOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { Button, message, Tooltip } from 'antd';
import { postConsultaRepuveNacional } from 'api/recaudacion/repuve';
import BusquedaAvanzadaVersion from 'components/BusquedaAvanzadaVersion';
import { InputSearchPro } from 'components/InputSearch';
import { capitalize, toInteger } from 'utils/normalizers';
import { ciudadanoToString, contribuyenteToString } from 'utils/padronesToString';
import { customUniqueValidator } from 'utils/rules';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import { afectacionesEnum, dataTypesEnum, padronesEnum } from 'views/Tramites/GPM/enums';

const REPUVE = process.env.REACT_APP_ENV_NAME === 'repuve';
const crud = window.location.pathname === '/padrones/vehicular/vehiculo';

const fieldsInfo = {
  marca: {
    id: 'marca',
    nombre_en_la_bd: 'marca',
    model: 'recaudacion.Marca',
    tipo_de_dato_del_campo: dataTypesEnum.FOREIGN_KEY,
  },
  es_propietario_ciudadano: {
    id: 'es_propietario_ciudadano',
    nombre_en_la_bd: 'es_propietario_ciudadano',
    tipo_de_dato_del_campo: dataTypesEnum.BOOLEAN,
  },
};

const fields = [
  'numero_de_identificacion_vehicular',
  'numero_de_placa_vigente',
  'registro_publico_vehicular',
  'clave_de_la_secretaria_de_hacienda_y_credito_publico',
];

const tabs = REPUVE ? [
  !crud && {
    title: '',
    fields,
  },
  {
    title: 'Información del Vehículo',
    icon: <InfoCircleOutlined />,
    fields: [
      crud && fields,
      'marca',
      'linea',
      'modelo',
      'version_vehicular',
      crud && [
        'es_propietario_ciudadano',
        'contribuyente_propietario',
        'propietario',
      ],
    ].filter((e) => e).flat(),
  },
  {
    title: 'Información General',
    icon: <IdcardOutlined />,
    fields: [
      'tarjeta_de_circulacion',
      'fecha_expedicion_placa',
    ],
  },
  {
    title: 'Características',
    icon: <FileDoneOutlined />,
    fields: [
      'tipo_de_vehiculo',
      'uso_del_vehiculo',
      'numero_de_puertas',
      'color_del_vehiculo',
      'numero_de_chasis',
      'numero_de_motor',
      'observaciones',
      'procedencia_vehiculo',
      'aduana',
      'nombre_de_la_aduana',
      'numero_de_patente',
      'numero_de_pedimento',
      'fecha_de_pedimento',
      'clave_del_importador',
    ],
  },
  {
    title: 'REPUVE',
    icon: <CarOutlined />,
    fields: [
      'rfv',
      'estatus_registro_repuve',
    ],
  },
].filter((e) => e) : [
  {
    title: 'Información General',
    icon: <IdcardOutlined />,
    fields: [
      'numero_de_placa_vigente',
      'fecha_de_expiracion_de_la_placa',
      'tipo_de_vehiculo',
      'numero_economico',
      'numero_de_identificacion_vehicular',
      'unidad_de_recaudacion',
      'tarjeta_de_circulacion',
      'es_propietario_ciudadano',
      'propietario',
      'contribuyente_propietario',
      'clave_de_repuve',
      'clave_de_servicio_publico',
      'capacidad_de_carga',
      'capacidad_de_pasajeros',
      'registro_publico_vehicular',
      'verificacion_tecnica_vehicular',
      'usuario_verificador',
      'es_fronterizo',
      'fecha_del_ultimo_movimiento',
      'tipo_de_tramite_vehicular',
      'estados_globales',
    ],
  },
  {
    title: 'Información del Vehículo',
    icon: <InfoCircleOutlined />,
    fields: [
      'marca',
      'linea',
      'version_vehicular',
      'modelo',
      'clase_del_vehiculo',
      'color_secundario',
      'color_del_vehiculo',
      'servicio',
      'es_foraneo',
      'pais',
      'exento_de_pago_de_tenencia',
      'tipo_de_tenencia_vehicular',
      'uso_del_vehiculo',
      'estatus_del_vehiculo',
      'numero_de_chasis',
      'numero_de_motor',
      'numero_de_puertas',
      'cilindraje',
      'tipo_de_combustible',
      'numero_de_calcomania',
      'peso_del_vehiculo',
      crud && 'observaciones',
    ].filter((e) => e),
  },
  {
    title: 'Facturación',
    icon: <FileDoneOutlined />,
    fields: [
      'clave_del_documento_de_regularizacion',
      'documentos_de_tramite',
      'es_vehiculo_nacional',
      'importe_de_la_factura',
      'fecha_de_la_factura',
      'numero_de_factura',
      'registro_publico_vehicular',
      !crud && 'observaciones',
    ],
  },
  {
    title: 'Repuve',
    icon: <CarOutlined />,
    fields: [
      !crud && 'clave',
      'fecha_de_repuve',
      'tipo_de_movimiento_repuve',
      'descripcion_de_la_agencia',
      'clave_de_la_secretaria_de_hacienda_y_credito_publico',
      'web_service',
      'aduana',
      'nombre_de_la_aduana',
      'numero_de_patente',
      'numero_de_pedimento',
      'fecha_de_pedimento',
      'clave_del_importador',
    ],
  },
];

const rulesRequiredByProcedencia = [
  ({ getFieldValue }) => ({
    validator: async (_, value) => {
      if (getFieldValue('procedencia_vehiculo') === 3 && !value) {
        throw new Error('El campo es requerido');
      }
    },
  }),
];

export const consultaRepuveNacional = async (field, value, callback) => {
  const valuesRepuve = await postConsultaRepuveNacional({ [field]: value });
  if (callback) callback(valuesRepuve);
  return valuesRepuve;
};

const getAddonAfter = (field) => (
  formInstance,
  _tab,
  _disabled,
  tipoDeAfectacion,
  setLoadingPartial,
) => {
  if (_disabled || !REPUVE || tipoDeAfectacion !== afectacionesEnum.ALTA
    || !window.location.pathname.includes('tramites/registrar-tramite')) return null;
  const _valuesRepuve = formInstance.getFieldValue('valuesRepuve');
  if (_valuesRepuve) {
    if (!_valuesRepuve.paramsConsulta[field]) return null;
    return (
      <Button
        type="link"
        onClick={() => formInstance.resetFields()}
      >
        <Tooltip title="Descartar consulta y limpiar formulario">
          <CloseCircleOutlined />
        </Tooltip>
      </Button>
    );
  }

  return (
    <Button
      type="link"
      onClick={async () => {
        formInstance.setFieldsValue({ valuesRepuve: undefined });
        let setValuesRepuve = false;
        let showMessage = false;
        try {
          await formInstance.validateFields([field]);
          setValuesRepuve = true;
        } catch (error) {
          showMessage = /ya existe/i.test(error.errorFields[0].errors[0]);
        }
        setLoadingPartial(true);
        await consultaRepuveNacional(
          field,
          formInstance.getFieldsValue()[field],
          (valuesRepuve) => setValuesRepuve && formInstance.setFieldsValue({ valuesRepuve }),
        );
        setLoadingPartial(false);
        if (showMessage) {
          message.info({
            content: (
              <>
                El vehículo ingresado ya se encuentra registrado,
                favor de realizar el trámite de &quot;Actualización de datos del vehículo&quot;
                <Button type="link" href="/tramites/registrar-tramite/?plantilla=3">
                  Ir
                  <ArrowRightOutlined />
                </Button>
              </>
            ),
            duration: 10,
          });
        }
      }}
    >
      <Tooltip title="Realizar consulta a webservice REPUVE">
        <SearchOutlined />
      </Tooltip>
    </Button>
  );
};

const configs = {
  // repuve
  rfv: {
    formItemProps: {
      label: 'RFV (NIV Vehículos Antiguos)',
      normalize: capitalize,
    },
  },
  estatus_registro_repuve: {
    formItemProps: {
      label: 'Estatus de registros vehiculares Repuve',
      normalize: toInteger,
    },
  },
  procedencia_vehiculo: {
    formItemProps: {
      label: 'Procedencia',
    },
    controlProps: {
      labelProp: 'descripcion',
    },
  },
  // informacion general
  numero_de_placa_vigente: {
    formItemProps: {
      label: 'Número de Placa Vigente',
      required: REPUVE,
      rules: [customUniqueValidator({ label: 'Número de Placa Vigente', tipoDePadron: 4 })],
      validateTrigger: 'onBlur',
      normalize: capitalize,
    },
    controlProps: {
      addonAfter: getAddonAfter('numero_de_placa_vigente'),
    },
  },
  fecha_de_expiracion_de_la_placa: {
    formItemProps: {
      label: 'Fecha De Expiración De La Placa',
    },
  },
  fecha_expedicion_placa: {
    formItemProps: {
      label: 'Fecha De Expedición De La Placa',
      required: true,
    },
  },
  tipo_de_vehiculo: {
    controlProps: {
      labelProp: 'nombre',
    },
    formItemProps: {
      label: 'Tipo de Vehículo',
      required: true,
    },
  },
  numero_economico: {
    formItemProps: {
      label: 'Número Económico',
    },
  },
  numero_de_identificacion_vehicular: {
    formItemProps: {
      label: REPUVE ? 'NIV' : 'Serie',
      tooltip: 'Número de Identificación Vehicular',
      normalize: capitalize,
      rules: [customUniqueValidator({ label: REPUVE ? 'NIV' : 'Serie', tipoDePadron: 4 })],
      validateTrigger: 'onBlur',
    },
    controlProps: {
      addonAfter: getAddonAfter('numero_de_identificacion_vehicular'),
    },
  },
  unidad_de_recaudacion: {
    formItemProps: {
      label: 'Unidad de Recaudación',
      rules: [{ required: !REPUVE }],
    },
  },
  tarjeta_de_circulacion: {
    formItemProps: {
      label: 'Tarjeta de Circulación',
      normalize: capitalize,
      rules: [{ required: REPUVE }],
    },
  },
  clave_de_repuve: {
    formItemProps: {
      label: 'Clave De Repuve',
      tooltip: 'Registro Público Vehícular',
      normalize: capitalize,
    },
  },
  clave_de_servicio_publico: {
    formItemProps: {
      label: 'Clave del Servicio Público',
      tooltip: 'Letras, números, guiones y guiones bajos',
      normalize: capitalize,
    },
  },
  capacidad_de_carga: {
    formItemProps: {
      label: 'Capacidad de Carga',
      tooltip: 'Capacidad de carga del vehículo',
    },
  },
  capacidad_de_pasajeros: {
    formItemProps: {
      label: 'Capacidad de Pasajeros',
      tooltip: 'Número de pasajeros para los que se diseñó el vehículo',
      required: true,
    },
  },
  registro_publico_vehicular: {
    formItemProps: {
      label: 'NCI No. de Constancia de Inscripción',
      normalize: capitalize,
      rules: [customUniqueValidator({ label: 'NCI No. de Constancia de Inscripción', tipoDePadron: 4 })],
      validateTrigger: 'onBlur',
      tooltip: '(antes RPV)',
    },
    // controlProps: {
    //   addonAfter: getAddonAfter('registro_publico_vehicular'),
    // },
  },
  verificacion_tecnica_vehicular: {
    formItemProps: {
      label: 'Verificación Técnica Vehicular',
    },
  },
  usuario_verificador: {
    advanced: true,
    control: InputSearchPro,
    label: 'Usuario Verificador',
    tooltip: 'Búsqueda por correo electrónico',
    resultProps: {
      name: 'usuario_verificador',
      label: 'Usuario Verificador',
      labelProp: 'email',
    },
    breakPoints: { md: 16 },
  },
  es_fronterizo: {
    formItemProps: {
      label: '¿Es fronterizo?',
    },
  },
  // no existe
  fecha_del_ultimo_movimiento: {
    hasntConfig: true,
    formItemProps: {
      label: 'Fecha Del Último Movimiento',
    },
  },
  // no existe
  tipo_de_tramite_vehicular: {
    hasntConfig: true,
    formItemProps: {
      label: 'Tipo De Trámite Vehicular',
    },
  },
  estados_globales: {},
  // informacion del vehiculo
  marca: {
    fkListIsPaginated: !REPUVE,
    controlProps: {
      labelProp: 'nombre',
    },
    formItemProps: {
      label: 'Marca',
      required: true,
    },
  },
  linea: {
    fkListIsPaginated: !REPUVE,
    params: ['marca'],
    controlProps: {
      labelProp: 'nombre',
    },
    formItemProps: {
      label: REPUVE ? 'Submarca' : 'Línea',
      required: true,
    },
  },
  version_vehicular: REPUVE ? {
    fkListIsPaginated: true,
    params: ['linea'],
    paramsEq: ['linea_vehicular'],
    controlProps: {
      labelProp: 'descripcion',
    },
    formItemProps: {
      label: 'Versión Vehicular',
      required: true,
    },
  } : {
    advanced: true,
    control: InputSearchPro,
    label: 'Versión Vehicular',
    tooltip: 'Búsqueda por descripción',
    resultProps: {
      name: 'version_vehicular',
      label: 'Versión Vehicular',
      labelProp: 'descripcion',
    },
    advancedComponent: BusquedaAvanzadaVersion,
  },
  modelo: {
    formItemProps: {
      label: 'Modelo',
      tooltip: 'Año del vehículo',
      required: true,
    },
  },
  clase_del_vehiculo: {
    controlProps: {
      labelProp: 'nombre',
    },
    formItemProps: {
      label: 'Clase del Vehículo',
      required: true,
    },
  },
  color_secundario: {
    formItemProps: {
      label: 'Color Secundario',
      required: true,
      normalize: capitalize,
    },
  },
  color_del_vehiculo: {
    formItemProps: {
      label: 'Color del Vehículo',
      required: true,
    },
  },
  servicio: {
    controlProps: {
      labelProp: 'nombre',
    },
    formItemProps: {
      label: 'Servicio',
      required: true,
    },
  },
  es_foraneo: {
    formItemProps: {
      label: '¿Es Foraneo?',
    },
    defaultValue: false,
    hideOnTruty: ['es_fronterizo'],
    hideOnFalsy: ['pais'],
  },
  pais: {
    fkListIsPaginated: true,
    formItemProps: {
      label: 'Pais',
      required: true,
    },
  },
  exento_de_pago_de_tenencia: {
    formItemProps: {
      label: '¿Exento De Pago De Tenencia?',
    },
    defaultValue: false,
  },
  tipo_de_tenencia_vehicular: {
    formItemProps: {
      label: 'Tipo De Tenencia',
    },
    hideOnTruty: ['exento_de_pago_de_tenencia'],
  },
  uso_del_vehiculo: {
    formItemProps: {
      label: 'Uso del Vehículo',
      required: true,
    },
  },
  estatus_del_vehiculo: {
    controlProps: {
      labelProp: 'nombre',
    },
    formItemProps: {
      label: 'Estatus del Vehículo',
      required: true,
    },
  },
  numero_de_chasis: {
    formItemProps: {
      label: 'Número de Chasis',
      normalize: capitalize,
    },
  },
  numero_de_motor: {
    formItemProps: {
      label: REPUVE ? 'Serie del Motor' : 'Número de Motor',
      normalize: capitalize,
      required: true,
    },
  },
  numero_de_puertas: {
    formItemProps: {
      label: 'Número de puertas',
      required: REPUVE,
    },
  },
  cilindraje: {
    formItemProps: {
      label: 'Cilindraje',
      required: true,
    },
  },
  tipo_de_combustible: {
    formItemProps: {
      label: 'Tipo de Combustible',
      required: true,
    },
  },
  numero_de_calcomania: {
    formItemProps: {
      label: 'Número de calcomanía',
      tooltip: 'Letras, números, guiones y guiones bajos',
      normalize: capitalize,
    },
  },
  peso_del_vehiculo: {
    formItemProps: {
      label: 'Peso del Vehículo',
    },
  },
  // Facuracion
  clave_del_documento_de_regularizacion: {
    controlProps: {
      keyLabelRender: true,
    },
    formItemProps: {
      label: 'Clave de Documento',
      required: false,
      normalize: capitalize,
    },
  },
  documentos_de_tramite: {
    controlProps: {
      keyLabelRender: true,
      mode: 'multiple',
    },
    formItemProps: {
      label: 'Documento del Trámite',
      required: false,
    },
  },
  es_vehiculo_nacional: {
    formItemProps: {
      label: 'Procedencia del vehículo',
      required: true,
    },
    defaultValue: true,
    controlProps: {
      trueFalse: ['Nacional', 'Extranjero'],
    },
  },
  importe_de_la_factura: {
    formItemProps: {
      label: 'Importe de la factura',
      required: true,
    },
  },
  fecha_de_la_factura: {
    formItemProps: {
      label: 'Fecha de la factura',
      required: true,
    },
  },
  numero_de_factura: {
    formItemProps: {
      label: 'Nofac',
      tooltip: 'Letras, números, guiones y guiones bajos',
      required: true,
      normalize: capitalize,
    },
  },
  observaciones: {
    formItemProps: {
      label: 'Observaciones',
      normalize: capitalize,
    },
    controlProps: {
      autoSize: { minRows: 3, maxRows: 3 },
    },
  },
  // repuve
  clave: {},
  fecha_de_repuve: {},
  tipo_de_movimiento_repuve: {
    controlProps: {
      autoSize: { minRows: 1, maxRows: 1 },
    },
    colProps: { md: 16 },
  },
  descripcion_de_la_agencia: {
    formItemProps: {
      label: 'Agencia Distribuidora',
      required: true,
      normalize: capitalize,
    },
    controlProps: {
      autoSize: { minRows: 1, maxRows: 1 },
    },
    colProps: { md: 12 },
  },
  clave_de_la_secretaria_de_hacienda_y_credito_publico: {
    formItemProps: {
      label: 'Clave Nacional (SHCP)',
      tooltip: 'Clave de la Secretaria de Hacienda y Crédito Público',
      normalize: capitalize,
      required: true,
    },
    controlProps: { maxLength: 7 },
    // colProps: { md: 12 },
  },
  web_service: {
    formItemProps: {
      label: 'Servicio Web',
      normalize: capitalize,
    },
  },
  aduana: {
    formItemProps: {
      label: 'Aduana',
      tooltip: 'Número de la seccion de la Aduana',
      normalize: capitalize,
    },
    showIf: (values) => [2, 3].includes(values.procedencia_vehiculo),
    updateOnChange: 'procedencia_vehiculo',
  },
  nombre_de_la_aduana: {
    formItemProps: {
      label: 'Nombre de aduana',
      normalize: capitalize,
    },
    showIf: (values) => [2, 3].includes(values.procedencia_vehiculo),
    updateOnChange: 'procedencia_vehiculo',
  },
  numero_de_patente: {
    formItemProps: {
      label: 'Número De Patente',
      normalize: capitalize,
    },
    showIf: (values) => [2, 3].includes(values.procedencia_vehiculo),
    updateOnChange: 'procedencia_vehiculo',
  },
  numero_de_pedimento: {
    formItemProps: {
      label: 'Número de pedimento',
      tooltip: 'Letras, números, guiones y guiones bajos',
      required: true,
      normalize: capitalize,
    },
    showIf: (values) => [2, 3].includes(values.procedencia_vehiculo),
    updateOnChange: 'procedencia_vehiculo',
  },
  fecha_de_pedimento: {
    formItemProps: {
      label: 'Fecha de pedimento',
      rules: rulesRequiredByProcedencia,
    },
    showIf: (values) => [2, 3].includes(values.procedencia_vehiculo),
    updateOnChange: 'procedencia_vehiculo',
  },
  clave_del_importador: {
    formItemProps: {
      label: 'Clave del importador',
      normalize: capitalize,
    },
    showIf: (values) => [2, 3].includes(values.procedencia_vehiculo),
    updateOnChange: 'procedencia_vehiculo',
  },
  propietario: {
    advanced: true,
    control: InputSearchPro,
    advancedComponent: BusquedaAvanzadaPadrones,
    advancedComponentProps: { tipoDePadron: padronesEnum.CIUDADANO, allowAdd: false },
    advancedComponentName: 'BusquedaAvanzadaPadrones',
    label: 'Ciudadano',
    tooltip: 'Búsqueda por clave ciudadana, correo electrónico, nombre completo',
    resultProps: {
      name: 'propietario',
      label: 'Ciudadano',
      render: (ciudadano) => ciudadanoToString(ciudadano),
    },
    showIf: (values) => values.es_propietario_ciudadano,
    breakPoints: { md: 16 },
    rules: [{ required: true }],
  },
  contribuyente_propietario: {
    advanced: true,
    control: InputSearchPro,
    advancedComponent: BusquedaAvanzadaPadrones,
    advancedComponentProps: { tipoDePadron: padronesEnum.CONTRIBUYENTE, allowAdd: false },
    advancedComponentName: 'BusquedaAvanzadaPadrones',
    label: 'Contribuyente',
    tooltip: 'Búsqueda por clave, correo electrónico, nombre completo, razón social',
    resultProps: {
      name: 'contribuyente_propietario',
      label: 'Contribuyente',
      render: (contribuyente) => contribuyenteToString(contribuyente),
    },
    showIf: (values) => !values.es_propietario_ciudadano,
    breakPoints: { md: 16 },
    rules: [{ required: true }],
  },
  es_propietario_ciudadano: {
    formItemProps: {
      label: 'Pertenece A',
    },
    controlProps: {
      trueFalse: ['Ciudadano', 'Contribuyente'],
      allowClear: false,
    },
  },
};

const forbiddenProps = [
  'propietario',
  'contribuyente_propietario',
  'marca_vehicular_estatal_nay',
  'impuesto_del_anio_2016',
  'recargo_del_anio_2016',
  'ultimo_ejercicio_pagado_de_refrendo',
  'importe_de_tenencia_actual',
  'recargo_de_tenencia_de_recargo_actual',
  'documentos_de_tramite',
];

export default {
  configs,
  forbiddenProps,
  fieldsInfo,
  tabs,
};
